import { useState } from 'react';

export function useOrders() {
  const [activeOrders, setActiveOrders] = useState([]);
  const [currentOrder, setCurrentOrder] = useState(null);
  const [showOrderPanel, setShowOrderPanel] = useState(false);
  const [newTableName, setNewTableName] = useState('');
  const [newCustomerName, setNewCustomerName] = useState('');

  const createTable = () => {
    if (!newTableName.trim()) return;
    const newOrder = {
      id: Date.now().toString(),
      type: 'table',
      name: newTableName,
      items: [],
    };
    setActiveOrders(prev => [...prev, newOrder]);
    setNewTableName('');
  };

  const createCustomer = () => {
    if (!newCustomerName.trim()) return;
    const newOrder = {
      id: Date.now().toString(),
      type: 'customer',
      name: newCustomerName,
      items: [],
    };
    setActiveOrders(prev => [...prev, newOrder]);
    setNewCustomerName('');
  };

  const selectOrder = (order) => {
    setCurrentOrder(order);
    setShowOrderPanel(true);
  };

  const addProductToOrder = (product) => {
    if (!currentOrder) return;

    const updatedOrders = activeOrders.map(order => {
      if (order.id === currentOrder.id) {
        const existingItem = order.items.find(item => item.productId === product.id);
        if (existingItem) {
          return {
            ...order,
            items: order.items.map(item =>
              item.productId === product.id
                ? { ...item, quantity: item.quantity + 1 }
                : item
            ),
          };
        } else {
          return {
            ...order,
            items: [
              ...order.items,
              {
                id: Date.now().toString(),
                productId: product.id,
                productName: product.name,
                price: product.price,
                quantity: 1,
              },
            ],
          };
        }
      }
      return order;
    });

    setActiveOrders(updatedOrders);
    setCurrentOrder(updatedOrders.find(order => order.id === currentOrder.id) || null);
  };

  const removeItemFromOrder = (item) => {
    if (!currentOrder) return;

    const updatedOrders = activeOrders.map(order => {
      if (order.id === currentOrder.id) {
        return {
          ...order,
          items: order.items.filter(i => i.id !== item.id),
        };
      }
      return order;
    });

    setActiveOrders(updatedOrders);
    setCurrentOrder(updatedOrders.find(order => order.id === currentOrder.id) || null);
  };

  const updateItemQuantity = (item, newQuantity) => {
    if (!currentOrder || newQuantity < 1) return;

    const updatedOrders = activeOrders.map(order => {
      if (order.id === currentOrder.id) {
        return {
          ...order,
          items: order.items.map(i =>
            i.id === item.id ? { ...i, quantity: newQuantity } : i
          ),
        };
      }
      return order;
    });

    setActiveOrders(updatedOrders);
    setCurrentOrder(updatedOrders.find(order => order.id === currentOrder.id) || null);
  };

  const calculateOrderTotal = (order) => {
    return order.items.reduce((total, item) => total + item.price * item.quantity, 0);
  };

  // ✅ Nueva función para cerrar ordenes (desde pagos exitosos)
  const closeOrder = (orderId) => {
    setActiveOrders(prev => prev.filter(order => order.id !== orderId));
    if (currentOrder?.id === orderId) {
      setCurrentOrder(null);
      setShowOrderPanel(false);
    }
  };

  return {
    activeOrders,
    currentOrder,
    showOrderPanel,
    setShowOrderPanel,
    newTableName,
    setNewTableName,
    newCustomerName,
    setNewCustomerName,
    createTable,
    createCustomer,
    selectOrder,
    addProductToOrder,
    removeItemFromOrder,
    updateItemQuantity,
    calculateOrderTotal,
    closeOrder, // ✅ exportamos también closeOrder
  };
}
